import { Page } from '@roc/feature-app-core';
import { Route } from 'react-router';
import { SecondAppraisalModal } from '@roc/feature-appraisals';

const LOANS_HOME_BASE_PATH = 'loans';
const LOAN_BASE_PATH = ':loanId';

export const getSecondAppraisalRoutesConfig = (
  basePath: string,
  baseUrl: string
) => {
  return {
    loans: (loanId?: string) => ({
      path: `${basePath}/${LOANS_HOME_BASE_PATH}/${LOAN_BASE_PATH}`,
      url: `${baseUrl}/${LOANS_HOME_BASE_PATH}/${loanId}`,
      children: {
        secondAppraisal: {
          path: `${basePath}/${LOANS_HOME_BASE_PATH}/${LOAN_BASE_PATH}/second-appraisal`,
          url: `${basePath}/${LOANS_HOME_BASE_PATH}/${loanId}/second-appraisal`,
          documentTitle: `${loanId} - Order Second Appraisal`,
        },
      },
    }),
  };
};

export const getSecondAppraisalRoutes = (
  basePath: string,
  baseUrl: string,
  loanId: any,
  propertyId: any
) => {
  const config = getSecondAppraisalRoutesConfig(basePath, baseUrl);
  return {
    secondAppraisal: (
      <Route exact path={config.loans().children.secondAppraisal.path}>
        <Page routeDefinition={config.loans().children.secondAppraisal}>
          <SecondAppraisalModal />
        </Page>
      </Route>
    ),
  };
};
